import { Icon } from "@iconify/react";
import React from "react";
import { Link } from "react-router-dom";
import { siteContact } from "../../data/siteContact";

const serviceMenuList = [
  {
    icon: "mdi:code-braces",
    title: "Web Application Development",
    href: "/service/web-application-development",
  },
  {
    icon: "mdi:brain",
    title: "AI & Machine Learning",
    href: "/service/ai-machine-learning",
  },
  {
    icon: "mdi:cellphone",
    title: "Mobile App Development",
    href: "/service/mobile-app-development",
  },
  {
    icon: "mdi:shield-check",
    title: "Cybersecurity Solutions",
    href: "/service/cybersecurity-solutions",
  },
  { icon: "mdi:palette", title: "UI/UX Design", href: "/service/ui-ux-design" },
  {
    icon: "mdi:cloud",
    title: "DevOps & Cloud Solutions",
    href: "/service/devops-cloud-solutions",
  },
];

const LinksMenuList = [
  { title: "Home", href: "/" },
  { title: "About", href: "/about" },
  { title: "Services", href: "/service" },
  { title: "Portfolio", href: "/portfolio" },
  { title: "Blog", href: "/blog" },
  { title: "Contact", href: "/contact" },
];

const policyMenuList = [
  { title: "Privacy Policy", href: "/privacy" },
  { title: "Terms of Use", href: "/terms" },
];

const socialBtnList = [
  { icon: "fa6-brands:linkedin-in", href: "https://www.linkedin.com/company/algostine/" },
  { icon: "fa6-brands:x-twitter" },
  { icon: "fa6-brands:youtube" },
];

export default function Footer() {
  return (
    <footer className="relative mt-8 overflow-hidden bg-gradient-to-b from-[#eaf3f4] via-[#f1f7f7] to-[#f8fbfb] text-slate-500">
      {/* Background wave lines */}
      <div className="pointer-events-none absolute bottom-0 left-0 right-0 opacity-[0.08]">
        <svg
          viewBox="0 0 1440 300"
          className="w-full h-[300px]"
          fill="none"
          stroke="#10B981"
          strokeWidth="1.5"
        >
          <path d="M0,150 Q360,80 720,150 T1440,150" />
          <path d="M0,180 Q360,110 720,180 T1440,180" />
          <path d="M0,210 Q360,140 720,210 T1440,210" />
          <path d="M0,240 Q360,170 720,240 T1440,240" />
          <path d="M0,270 Q360,200 720,270 T1440,270" />
        </svg>
      </div>

      <div className="relative z-10 mx-auto max-w-[1450px] px-8 pb-[70px] pt-[90px] max-[991px]:py-[60px] max-[575px]:px-6">
        <div className="grid grid-cols-1 gap-x-12 gap-y-12 sm:grid-cols-2 lg:grid-cols-12">
          {/* Brand & Address */}
          <div className="lg:col-span-3">
            <div className="mb-6 h-[62px] w-[205px] overflow-hidden">
              <img
                src="/images/logo.png"
                alt="Algostine"
                className="h-[205px] w-[205px] max-w-none object-contain"
                style={{ marginTop: "-71px" }}
              />
            </div>
            <p className="mb-6 text-[16.5px] leading-[1.75] text-slate-500">
              We engineer secure, scalable and high-performance digital
              solutions that help businesses grow without limits.
            </p>
            <div className="w-10 h-[2.5px] bg-brand-teal rounded-full mb-7" />

            <ul className="list-none m-0 p-0 space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-brand-teal/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Icon
                    icon="mdi:map-marker-outline"
                    className="w-[16px] h-[16px] text-brand-teal"
                  />
                </div>
                <span className="text-[15.5px] text-gray-500 leading-[1.65] pt-1">
                  D-166/2 D Block Sector 50
                  <br />
                  Noida 201301, India
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-brand-teal/10 flex items-center justify-center flex-shrink-0">
                  <Icon
                    icon="mdi:phone-outline"
                    className="w-[16px] h-[16px] text-brand-teal"
                  />
                </div>
                <a
                  href={siteContact.phoneHref}
                  className="text-[15.5px] text-gray-500 hover:text-brand-teal"
                >
                  {siteContact.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-brand-teal/10 flex items-center justify-center flex-shrink-0">
                  <Icon
                    icon="mdi:email-outline"
                    className="w-[16px] h-[16px] text-brand-teal"
                  />
                </div>
                <a
                  href={siteContact.emailHref}
                  className="text-[15.5px] text-gray-500 hover:text-brand-teal"
                >
                  {siteContact.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="lg:col-span-4 lg:pl-8">
            <h2 className="mb-2 text-[22px] font-bold text-slate-900">
              Services
            </h2>
            <div className="w-10 h-[2.5px] bg-brand-teal rounded-full mb-7" />
            <ul className="list-none m-0 p-0 space-y-4">
              {serviceMenuList.map((item, index) => (
                <li key={index}>
                  <Link
                    to={item.href}
                    className="flex items-center gap-3 text-gray-500 hover:text-brand-teal transition-colors duration-200 text-[16px] group"
                  >
                    <Icon
                      icon={item.icon}
                      className="w-[16px] h-[16px] text-brand-teal/70 group-hover:text-brand-teal transition-colors flex-shrink-0"
                    />
                    <span>{item.title}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Links */}
          <div className="lg:col-span-2">
            <h2 className="mb-2 text-[22px] font-bold text-slate-900">Links</h2>
            <div className="w-10 h-[2.5px] bg-brand-teal rounded-full mb-7" />
            <ul className="list-none m-0 p-0 space-y-4">
              {LinksMenuList.map((item, index) => (
                <li key={index}>
                  <Link
                    to={item.href}
                    className="flex items-center gap-2 text-gray-500 hover:text-brand-teal transition-colors duration-200 text-[16px] py-0.5"
                  >
                    <Icon
                      icon="mdi:chevron-right"
                      className="w-3.5 h-3.5 text-brand-teal/50"
                    />
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact CTA */}
          <div className="lg:col-span-3">
            <div className="rounded-2xl border border-brand-teal/15 bg-brand-teal/[0.06] p-7 shadow-[0_10px_35px_rgba(15,23,42,0.05)]">
              <div className="w-14 h-14 rounded-full bg-brand-teal/10 flex items-center justify-center mb-5">
                <Icon
                  icon="mdi:send-outline"
                  className="w-6 h-6 text-brand-teal"
                />
              </div>
              <h3 className="mb-2 text-[22px] font-bold text-slate-900">
                Let&apos;s build something great
              </h3>
              <p className="text-[15.5px] text-gray-400 leading-[1.7] mb-6">
                Have a project in mind? Talk to our team about your next digital
                product.
              </p>
              <Link
                to="/contact"
                className="w-full h-[48px] rounded-xl bg-brand-teal text-white text-[15.5px] font-semibold hover:bg-[#155568] transition-all duration-300 flex items-center justify-center gap-2 shadow-[0_4px_15px_rgba(27,102,122,0.25)] hover:shadow-[0_6px_20px_rgba(27,102,122,0.35)]"
              >
                Contact Us
                <Icon icon="mdi:send-outline" className="w-3.5 h-3.5" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="mx-auto max-w-[1450px] px-8 max-[575px]:px-6">
        <div className="flex flex-wrap items-center justify-between gap-4 border-t border-slate-200/70 py-6 text-slate-400 max-[767px]:flex-col max-[767px]:text-center">
          <div className="flex flex-wrap gap-2">
            {socialBtnList.map((item, index) => {
              const SocialElement = item.href ? "a" : "span";
              return (
              <SocialElement
                {...(item.href ? { href: item.href, target: "_blank", rel: "noreferrer" } : {})}
                key={index}
                className="flex items-center justify-center w-8 h-8 rounded-full border border-gray-300 text-gray-600 hover:border-brand-teal hover:text-brand-teal transition-all duration-200"
              >
                <Icon icon={item.icon} className="w-3 h-3" />
              </SocialElement>
            );})}
          </div>
          <div className="text-[14.5px]">Copyright &copy; 2026 Algostine.</div>
          <ul className="flex flex-wrap list-none m-0 p-0 gap-0">
            {policyMenuList.map((item, index) => (
              <li key={index} className="flex items-center">
                {index > 0 && <span className="mx-2 text-gray-300">|</span>}
                <Link
                  to={item.href}
                  className="text-gray-400 hover:text-brand-teal transition-colors duration-200 text-[14.5px]"
                >
                  {item.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}
